// import { AmChart, AmChartsService } from "@amcharts/amcharts3-angular";
import * as am4charts from '@amcharts/amcharts4/charts';
import * as am4core from '@amcharts/amcharts4/core';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { DateTimeFormat } from 'src/app/shared/pipes/dateTimeFormat.pipe';
import { MasterscreenService } from '../../../masterscreen/services/masterscreen.service';
import { BaseService } from '../../../shared/services/base.service';
import { Category, Guide, Section, Segment } from '../../model/task.model';
import { TaskConstantsService } from '../../services/task-constants.service';
import { TaskService } from '../../services/task.service';

@Component({
  selector: 'ara-monitoring-matrix',
  templateUrl: './monitoring-matrix.component.html',
  styleUrls: ['./monitoring-matrix.component.css'],
})
export class MonitoringMatrixComponent implements OnInit {
  // private chart: AmChart;
  sectionList: { label: string; value: string }[] = [];
  taskDetailsResponse: Section[];
  sectionDetailsResponse: Section[];
  guideData = new Guide();
  chartGuideData: Guide[] = [];
  segmentData: Segment[] = [];
  categoryData: Category[] = [];
  SectionList: any[];
  SectionIds: any[];
  selectedStatus: any[];
  TaskList: any[];
  periodList = [
    { label: 'Select', value: null },
    { label: 'Monthly', value: 'Monthly' },
    { label: 'Quarterly', value: 'Quarterly' },
    { label: 'Daily', value: 'Daily' },
    { label: 'Weekly', value: 'Weekly' },
  ];
  selectedPeriodList: any;
  taskListResponse: any[] = [];
  routesFlag: { routeName: string; routeURL: string; isClickable: boolean }[];
  reportRoutes: { routeName: string; routeURL: string; isClickable: boolean }[];
  options: { type: string; theme: string; dataProvider: any[] };
  MonitoringMatrixdata: any[] = [];
  viewType: string = 'monthly';
  guidesList: any[];
  dataLoaded: boolean = false;
  monitoringMatrixNames: any[];
  selectedMatrix: any;
  columnList: { key: string; value: string }[];
  jsonString: string;
  graphHeight: number = 100;
  enableZoomout: boolean = false;
  TaskName: string;
  TaskId: string;
  ActionId: string;
  DueDate: string;
  ActionOwner: string;
  ActionParty: string;
  ActionVerifier: string;
  ClosedDate: string;
  Status: string;
  data: any[] = [];
  showLegend: boolean = false;
  showZoomOutButton: boolean = false;
  datePipe: DateTimeFormat = new DateTimeFormat(); 
  dataCount: number = 0;
  constructor(
    private taskService: TaskService,
    public baseService: BaseService,
    private masterscreenService: MasterscreenService,
    // private AmCharts: AmChartsService,
    private router: Router,
    public httpClient: HttpClient,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    this.masterscreenService.getAllMonitoringMatrixName(
      null,
      this.callbackMethodForGetAllMonitoringMatrixName.bind(this)
    );
    // Set routeURL and route name
    let routes = JSON.stringify(
      TaskConstantsService.TaskNavigation.InnerRoutes
    );
    this.routesFlag = JSON.parse(routes);
    this.reportRoutes = TaskConstantsService.TaskNavigation.ReportRoutes;
    const permissions = JSON.parse(
      this.baseService.getItemFromSession('UserIndependentPermissions')
    );
    if (
      !permissions.TSK_Add &&
      !permissions.TSK_Add_Unit &&
      !permissions.TSK_Admin &&
      !permissions.TSK_Admin_Unit
    ) {
      for (let index = 0; index < this.routesFlag.length; index++) {
        if (this.routesFlag[index].routeName === 'Task Setup') {
          this.routesFlag.splice(index, 1);
        }
      }
    }
    this.baseService.translatorListener.subscribe((data) => {
      this.translate.use(data);
    });
  }
  callbackMethodForGetAllMonitoringMatrixName(response) {
    this.monitoringMatrixNames = [];
    response.Result.forEach((element) => {
      this.monitoringMatrixNames.push({
        label: element.MatrixName,
        value: element.MatrixId,
      });
    });
  }

  getColor(status: string) {
    switch (status) {
      case 'Overdue':
        return 'red';
      case 'Done':
        return 'green';
      case 'Done With Overdue':
        return 'orange';
      case 'Scheduled':
        return 'yellow';
      case 'To be Scheduled':
        return '#007AC6';
      default:
        return '#993333';
    }
  }

  legend = [
    { lebel: 'Overdue', color: 'red' },
    { lebel: 'Done', color: 'green' },
    { lebel: 'Done With Overdue', color: 'orange' },
    { lebel: 'Scheduled', color: 'yellow' },
    { lebel: 'To be Scheduled', color: '#007AC6' }
  ]

  getMonitoringMatrixData() {
    this.baseService.showRootLoader = true;
    const apiRequest = {
      Model: {
        ViewType: this.viewType,
        Sections: this.selectedStatus,
        MatrixId: this.selectedMatrix,
      },
    };
     
    this.taskService.getMonitoringMatrix(
      apiRequest,
      this.callbackMethodForMonitoringMatrix.bind(this)
    );
  }
  callbackMethodForMonitoringMatrix(response) {
    this.MonitoringMatrixdata = response.Result;
    this.data = [];
    this.MonitoringMatrixdata.forEach((x) =>
      this.data.push({
        name: x.Name,
        fromDate: x.StartDate,
        toDate: x.EndDate,
        color: this.getColor(x.Status),
        sectionName: x.SectionName,
        tooltip:'Task Name : ' + x.Name +'\n'+
        'Task Id : ' + x.TaskId +'\n'+
        'Action Id : ' +x.ActionId+'\n'+
        'Due Date : ' +((x.DueDate) ? (this.datePipe.transform(moment(moment.utc(x.DueDate).local()).toDate(),'MMM D, YYYY').toString()):'N/A')+'\n'+
        'Action Owner : ' + (x.ActionOwnerFullName ? x.ActionOwnerFullName : 'N/A') +'\n'+
        'Action Verifier : ' + (x.ActionVerifierFullName ? x.ActionVerifierFullName: 'N/A' )+'\n'+
        'Action Party : ' +(x.ActionPartyFullName ? x.ActionPartyFullName : 'N/A') +'\n'+
        'Close Date : ' + ((x.EndDate) ? (this.datePipe.transform(moment(moment.utc(x.EndDate).local()).toDate(),'MMM D, YYYY').toString()):'N/A') +'\n'+
        'Status : ' +x.Status+'\n',
        tooltipYaxis:'Task : ' + x.Name +'\n'+ 'Section : ' + x.SectionName
      })
    );
    this.guidesList = [];
    let groupedData = this.groupBy(
      this.MonitoringMatrixdata,
      (segments) => segments.Name
    );
    this.categoryData = [];
 
    //this.dataCount = (this.sectionList.length + this.data.length) * 20;
    groupedData.forEach((element) => {
      const category = new Category();
      category.category = element.entries().next().value[1].Name;
      this.categoryData.push(category);
    });
    this.dataCount = (this.selectedStatus.length + this.categoryData.length) * 80;
    this.MonitoringMatrixdata.forEach((matrix) => {
      this.categoryData.forEach((category) => {
        if (matrix.Name === category.category) {
          const segment = new Segment();
          segment.start = new Date(matrix.StartDate);
          segment.end = new Date(matrix.EndDate);
          segment.task = matrix.Name;
          segment.Status = matrix.Status;
          segment.TaskId = matrix.TaskId;
          segment.SectionId = matrix.SectionId;
          segment.OriginalSectionName = matrix.SectionName;
          segment.SectionName =
            matrix.SectionName.length > 15
              ? matrix.SectionName.substring(0, 15) + '...'
              : matrix.SectionName;
          segment.ActionId = matrix.ActionId === 0 ? 'NA' : matrix.ActionId;
          segment.ActionOwner =
            matrix.ActionOwner.FullName === null
              ? 'NA'
              : matrix.ActionOwner.FullName;
          segment.ActionParty =
            matrix.ActionParty.FullName === null
              ? 'NA'
              : matrix.ActionParty.FullName;
          segment.ActionVerifier =
            matrix.ActionVerifier.FullName === null
              ? 'NA'
              : matrix.ActionVerifier.FullName;
          segment.ClosedDate =
            matrix.ClosedDate === null
              ? 'NA'
              : new Date(matrix.ClosedDate).toDateString();
          segment.DueDate = new Date(matrix.ScheduledDate).toDateString();
          switch (matrix.Status) {
            case 'Done':
              segment.color = 'green';
              segment.labelColor = 'white';
              segment.label = 'D';
              break;
            case 'Overdue':
              segment.color = 'red';
              segment.labelColor = 'white';
              segment.label = 'O';
              break;
            case 'Done With Overdue':
              segment.color = 'orange';
              segment.labelColor = 'black';
              segment.label = 'I';
              break;
            case 'Scheduled':
              segment.color = 'yellow';
              segment.labelColor = 'black';
              segment.label = 'S';
              break;
            case 'To be Scheduled':
              segment.color = '#007AC6';
              segment.labelColor = '#fff';
              segment.label = 'TBS';
              break;
            default:
              segment.color = 'lightblue';
              segment.labelColor = 'black';
              segment.label = matrix.Status;
              break;
          }
          segment.Report = matrix.ReportURL;
          segment.RecurrencePeriod = matrix.RecurrencePeriod;
          category.segments.push(segment);
        }
      });
    });
    //for loop on selected sections, then use category data for loop to push matched category data in guide
    let tempCategories = [];
    this.selectedStatus.forEach((section) => {
      tempCategories = [];
      this.categoryData.forEach((category) => {
        category.segments.forEach((segment) => {
          if (section === segment.SectionId) {
            tempCategories.push(category);
            return;
          }
        });
      });
      if (tempCategories.length > 0) {
        let guide = new Guide();
        guide.category = tempCategories[0].category;
        guide.toCategory = tempCategories[tempCategories.length - 1].category;
        guide.label = this.SectionList.find((sec) => {
          if (sec.value === section) {
            return sec;
          }
        }).label;
        guide.label =
          guide.label.length > 15
            ? guide.label.substring(0, 15) + '...'
            : guide.label;
        this.guidesList.push(guide);
      }
    });
    this.graphHeight =
      this.categoryData.length > 1
        ? this.categoryData.length * 50
        : this.categoryData.length * 100;
    this.dataLoaded = true;
    this.ganttChart();

    this.baseService.showRootLoader = false;
  }
  groupBy(list, keyGetter) {
    const map = new Map();
    list.forEach((item) => {
      const key = keyGetter(item);
      const collection = map.get(key);
      if (!collection) {
        map.set(key, [item]);
      } else {
        collection.push(item);
      }
    });
    return map;
  }
  callbackMethodForGetTaskSection(response) {
    this.SectionList = [];
    if (response && response.Result.length > 0) {
      response.Result.forEach((item) => {
        this.SectionList.push({
          label: item.SectionName,
          value: item.SectionId,
        });
        this.selectedStatus.push(item.SectionId);
      });
    }
  }
  getSectionData() {
    this.selectedStatus = [];
    const apiRequest = {
      Model: {
        MatrixId: this.selectedMatrix,
      },
    };
    this.taskService.getTask(
      apiRequest,
      this.callbackMethodForGetTaskSection.bind(this)
    );
  }
  onClickBack() {
    this.router.navigate(['../home']);
  }

  ganttChart() {
    /* Chart code */
    // Themes begin
    am4core.useTheme(am4themes_animated);
    // Themes end

    let chart = am4core.create('chartdiv', am4charts.XYChart);
    chart.hiddenState.properties.opacity = 0; // this creates initial fade-in

    chart.paddingRight = 30;
    chart.dateFormatter.inputDateFormat = 'yyyy-MM-dd HH:mm';

    let colorSet = new am4core.ColorSet();
    colorSet.saturation = 0.4;

    chart.data = [...this.data];

    let categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = 'name';
    categoryAxis.renderer.grid.template.location = 0;
    categoryAxis.renderer.inversed = true;
    categoryAxis.tooltipText = '{tooltipYaxis}';
    let label = categoryAxis.renderer.labels.template;
    label.wrap = true;
    label.maxWidth = 320;

    let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
    dateAxis.dateFormatter.dateFormat = 'yyyy-MM-dd HH:mm';
    // dateAxis.renderer.minGridDistance = 70;
    // //dateAxis.baseInterval = { count: 30, timeUnit: 'minute' };
    // dateAxis.max = new Date(2018, 0, 1, 24, 0, 0, 0).getTime();
    // dateAxis.strictMinMax = true;
    dateAxis.renderer.tooltipLocation = 0;

    let series1 = chart.series.push(new am4charts.ColumnSeries());
    series1.columns.template.width = am4core.percent(80);
   // series1.columns.template.height = 200;
    // series1.adapter.add("tooltipHTML", (Text, target) => {
    //   let context = target.tooltipDataItem.dataContext
    //   return `Task Name : ${context['task']}<br />
    //   Task Id : ${context['TaskId']} <br />
    //   Action Id : ${context['ActionId']} <br />
    //   Due Date : ${context['DueDate']} <br/>
    //   Action Owner : ${context['ActionOwner']} <br />
    //   Action Party : ${context['ActionParty']} <br />
    //   Action Verifier : ${context['ActionVerifier']} <br />
    //   Close Date : ${context['ClosedDate']} <br />
    //   Status : ${context['Status']} <br />
    //   ClosureReport: <strong>Double click to download</strong>`});

    series1.dataFields.openDateX = 'fromDate';
    series1.dataFields.dateX = 'toDate';
    series1.dataFields.categoryY = 'name';
    series1.columns.template.propertyFields.fill = 'color'; // get color from data
    series1.columns.template.propertyFields.stroke = 'color';
    series1.columns.template.strokeOpacity = 1;
    series1.columns.template.tooltipText = '{tooltip}';
    // series1.tooltip = new am4core.Tooltip();
    // series1.tooltipText = "This button will use own instance of Tooltip";
    // series1.tooltip.disabled = true;

    let sections: any[] = [];
    chart.data.forEach((x) => {
      if (!sections.some((s) => x.sectionName === s.sectionName)) {
        let cat = this.categoryData.filter(
          (c) => c.segments[0].OriginalSectionName === x.sectionName
        );
        if (cat.length > 0) {
          sections.push({
            start: cat[0].category,
            end: cat[cat.length - 1].category,
            sectionName: x.sectionName,
          });
        }
      }
    });

    function createRange(label, start, end) {
      let range = categoryAxis.axisRanges.create();
      range.category = start;
      range.endCategory = end;
      range.label.text = label;
      range.label.paddingBottom = 40;
      range.label.paddingRight = 30;
      range.label.textAlign = 'start';
      range.label.location = 0;
      range.label.fontWeight = 'bolder';
      range.grid.disabled = true;
      range.label.wrap = true;
      range.label.marginTop = 20;
    }

    sections.forEach((e) => {
      createRange(e.sectionName, e.start, e.end);
    });

    this.showLegend = true;

    //  chart.legend = new am4charts.Legend();

    chart.exporting.menu = new am4core.ExportMenu();
    chart.exporting.menu.align = 'left';
    chart.exporting.menu.verticalAlign = 'top';

    chart.scrollbarX = new am4core.Scrollbar();
    chart.scrollbarY = new am4core.Scrollbar();
    chart.cursor = new am4charts.XYCursor();
    chart.cursor.maxTooltipDistance = -1

    this.showZoomOutButton = true;
  }
}
